import {
    EpgProgram,
    MixedItem,
    RBLink,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

const mockDeeplink: RBLink = {
    id: 'Nagra_DL_4359948_1520',
    contentRef: 'SimplyTV_4359948_1520',
    period: {
        duration: 65710799,
        start: 1638316800,
        end: 1704027599,
    },
    provider: 'Nagra',
    deviceType: ['ATV', 'IOS', 'Android'],
    original: false,
    type: 'universal',
    action: 'playmedia',
    url: 'https://www.nagra.com/tvshows/papahatkeinenplan/5JIB4odrBDXw',
    playbackOptions: [
        {
            price: 10,
            definition: 'HD',
            currency: 'USD',
            license: 'Nfg2R1',
        },
    ],
    playbackParams:
        '[{"key": "page", "value": "content_playout"}, {"key": "id", "value": "AFWGGSSJIB4odrBDXw"}, {"key": "appleAppId", "value": "872394298347"}, {"key": "androidBundleId", "value": "com.nagra.ion"}, {"key": "appleBundleLink", "value": "ion://tvshows/papahatkeinenplan/5JIB4odrBDXw"}]',
};

const getMockDeeplink = (possibleToOpen: boolean = true): RBLink => {
    return possibleToOpen ? (mockDeeplink as RBLink) : (mockDeeplink as RBLink);
};

export function makeTestDeeplinkTitle(
    item:
        | EpgProgram
        | RBProgram
        | MixedItem
        | SearchProgram
        | RecordingMetadata,
    title: string,
) {
    return title;
    // TODO Use only for testing Deeplink items.
    // return isDeeplinkItem(item) ? `DL ${title}` : title;
}

export default getMockDeeplink;
